export function NoAccessPage() {
    return <h1>No access!</h1>
}